import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// Shown for unknown URLs. The production host serves dist/404.html with a real
// 404 status for these (see scripts/generate-static.js); this page is what the
// SPA renders once it boots there.
export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found | Indian Codes Hub</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Page not found</h1>
        <p className="text-gray-600 mb-6">The page you are looking for does not exist.</p>
        <Link to="/" className="text-sky-600 hover:underline">
          Go to the Indian Codes Hub home page
        </Link>
      </div>
    </>
  );
}
